module.exports = __webpack_public_path__ + "static/img/c-logo.8fbc363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c-logo.png
// module id = J+uo
// module chunks = 9